import merge from 'lodash/merge.js';

import Media from '@/models/Media.js';
import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class CourseCodes extends Model {
    static entity = 'course-codes';

    static modelName = 'courseCodes';

    static queryBuilder(id = null) {
        const endpoint = id ? `${this.entity}/${id}` : this.entity;

        return new QueryBuilder(endpoint);
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            items: this.attr([]),
            instantiated_evaluations: this.attr([]),

            ...super.fields(),
        };
    }

    static fetch(id) {
        return this.api().get(this.queryBuilder(id).toUrl());
    }

    static fetchAttachments(id, location) {
        return this.api().get(new QueryBuilder(`${this.entity}/${id}/attachments`).raw({ location }).toUrl());
    }

    static fetchAll({ page = 1, sort = { field: 'name', order: 'asc' } }) {
        return this.api().get(this.queryBuilder().page(page).sort(sort.field, sort.order).toUrl());
    }

    static add(payload) {
        this.api().post(this.queryBuilder().toUrl(), payload);
    }

    static async updateField(model, payload) {
        await this.api().put(
            this.queryBuilder(model.id).toUrl(),
            merge(model, {
                [payload.field]: payload.input,
            })
        );

        model.$update({
            where: model.id,
            data: {
                [payload.field]: payload.input,
            },
        });
    }

    static remove(model) {
        this.api().delete(this.queryBuilder(model.id).toUrl(), { save: false });

        model.$delete();
    }

    static async addMediaAttachment(model, media, type) {
        const data = await this.api().put(this.queryBuilder(model.id).toUrl(), {
            media,
            attachment_type: type,
        });

        this.fetch(model.id).then(({ resp }) => {
            model.$update({
                where: model.id,
                data: resp.response.data,
            });
        });

        return data.response.data;
    }

    static async deleteMediaAttachment(courseCode, media) {
        await Media.deleteModel(this.entity, courseCode.id, media.id);

        this.fetch(courseCode.id).then(({ data }) => {
            courseCode.$update({
                where: courseCode.id,
                data: data.response.data,
            });
        });
    }

    static async updateMediaAttachment(courseCode, media, payload) {
        await Media.updateModel(this.entity, courseCode.id, media.id, payload);

        this.fetch(courseCode.id).then(({ data }) => {
            courseCode.$update({
                where: courseCode.id,
                data: data.response.data,
            });
        });
    }
}
